const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const baggagesManagerMixin = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/mixins/baggages_manager.mixin');
const baggagesObserverMixin = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/mixins/baggages_observer.mixin');
const trackingUtils = require('../tracking/utils').default;
const checkedBagsOneClickUtils = require('../../../utils/checked_bags_one_click');


const IS_SELECTED_CLASS = 'od-baggage-added';
const ICON_CLASS = {
    ROUNDTRIP: 'odf-icon-round-trip',
    DEPARTURE: 'odf-icon-departure',
};

module.exports = withCachedSelectors(BaseView.extend(baggagesObserverMixin.extend(baggagesManagerMixin.extend( {
    selectors: {
        segmentInfo: '.segment_info',
        segmentOffer: '.segment_offer',
        segmentIncludedInfo: '.segment_included_info',
    },
    events: {
        'tap .select_baggage_view': 'onAddButtonClicked',
        'tap .baggage_remove': 'onBaggageRemove',
        'tap .remove_baggage_segment': 'onBaggageRemove',
        'tap .baggage_autoselection_link': 'onDisableAutoSelection',
    },
    initialize(options) {
        this.isAutoSelectionStillValid = options.isAutoSelectionStillValid;
        this.applyAutoSelection = options.applyAutoSelection;
        this.notifyAutoSelectionChanged = options.notifyAutoSelectionChanged;
        this.ancillaryContainer = options.ancillaryContainer;
        this.baggageSelector = options.baggageSelector;

        this.bindEvents();

        this.model.setData({
            ...{requestType: options.requestType},
            ...options.baggageRow,
            doesAnySegmentHaveASelectableBaggage: options.doesAnySegmentHaveASelectableBaggage,
            autoSelectionActive: options.autoSelectionAvailable,
        });

        const secondSegmentOption = this.getBaggagesRowSelection(
            this.model.get('idPassenger'),
            this.model.get('idRow')
        );

        if (secondSegmentOption) {
            this.updateAutoSelection(secondSegmentOption);
        }
    },
    bindEvents() {
        this.listenTo(this.model, 'change:selectedBaggage', this.render);
        this.listenTo(this.model, 'change:autoSelectionActive', this.render);
        this.listenTo(this.model, 'change:autoSelectionActive', this.notifyAutoSelectionChanged);
        this.suscribeOnBaggageChangeEvent();
    },
    onDisableAutoSelection: function(evt) {
        evt.preventDefault();
        this.model.set('autoSelectionActive', false);
        trackingUtils.onChange.call(this);
    },
    onAddButtonClicked(evt) {
        evt.stopPropagation();
        evt.preventDefault();

        this.model.get('offerAdditionalBaggage')
            ? trackingUtils.onClickExtra.call(this)
            : trackingUtils.onClick.call(this);

        this.baggageSelector.execute('update', {
            ...this.model.toJSON(),
            evt,
            shouldSplitPrice: this.model.shouldSplitPrice(),
        }, this);

        this.baggageSelector.execute('open');
    },
    changeSelection(newOptionID) {
        this.updateBaggageSelection({
            newOptionCid: newOptionID,
            isUserAction: true,
            triggerEvents: true,
        });

        trackingUtils.onClickOption.call(this);
    },
    onBaggageRemove: function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        const rowCid = $(evt.currentTarget).data().row;
        this.removeSelection(rowCid);
        trackingUtils.onRemove.call(this);
    },
    removeSelection: function(rowCid) {
        const row = this.getBaggageRowByCid(rowCid);
        const idRow = row.get('idRow');
        const isUserAction = true;
        this.selectDefaultOption(row.get('idPassenger'), idRow, isUserAction);
    },
    onCloseSelector: function() {
        trackingUtils.onCloseSelector.call(this);
    },
    onBaggageChange(data) {
        const currentModelSelection = this.model.get('selectedBaggage');
        const oldSelectionFromData = data.previousOption;
        const newSelectionFromData = data.currentOption;
        if (currentModelSelection === oldSelectionFromData) {
            this.model.set('selectedBaggage', newSelectionFromData);
            this.applyAutoSelection(this.model.get('selectedBaggage'));
            this.updateAutoSelection(newSelectionFromData);
        }
    },
    updateAutoSelection(selectedBaggage) {
        const isSecondLeg = this.model.isSecondLeg();
        const autoSelectionActive = this.model.hasAutoSelectionActive();
        if (isSecondLeg && autoSelectionActive) {
            const isAutoSelectionStillValid = this.isAutoSelectionStillValid(selectedBaggage);
            this.model.set('autoSelectionActive', isAutoSelectionStillValid);
        }
    },
    autoSelect(newOption) {
        if (this.model.hasAutoSelectionActive()) {
            if (!Odigeo._.isUndefined(newOption)) {
                this.updateBaggageSelection({
                    newOptionCid: newOption.cid,
                    isUserAction: false,
                    triggerEvents: true,
                });
            }
        }
    },
    render() {
        const data = this.model.toJSON();
        data.isSimilarSelection = checkedBagsOneClickUtils.isSelectionFromOneClick(data.idRow, data.selectedBaggage) &&
            checkedBagsOneClickUtils.isSimilarSelection(
                checkedBagsOneClickUtils.__selection__,
                data.selectedBaggage
            );
        this.$el.html(this.templates.main({
            rowInfo: data,
            keys: this.keys,
            debugInfo: data.debugInfo,
        }));
        this.renderSegmentInfo(data);
        this.renderSegmentOfferByScenario(data);
    },

    renderSegmentOfferByScenario(data) {
        if (this.model.hasSelectableBaggage()) {
            this.renderSegmentOffer(data);
        } else if (this.model.hasIncludedBaggage()) {
            this.renderIncludedBaggageInfo(data);
        } else {
            this.renderNotAllowedBaggageInfo(data);
        }
    },
    renderNotAllowedBaggageInfo() {
        this.$el.find(this.selectors.segmentOffer).html(this.templates.notAllowedSegment({
            rowCollectionId: this.model.get('rowCollectionId'),
            keys: {
                segmentNotAllowedTitle: this.keys.segmentNotAllowedTitle,
            },
        }));
    },
    renderIncludedBaggageInfo(data) {
        const firstOption = Odigeo._.first(data.options);
        const kilos = firstOption.get('kilos');
        const pieces = firstOption.get('pieces');
        const doesAnySegmentHaveASelectableBaggage = this.model.doesAnySegmentHaveASelectableBaggage();

        const includedSegment = this.templates.includedSegment({
            pieces,
            kilos,
            keys: this.keys,
        });

        this.$el.find(this.selectors.segmentOffer).html(this.templates.includedSegmentWrapper({
            includedSegment,
            doesAnySegmentHaveASelectableBaggage,
            keys: this.keys,
        }));
    },
    renderSegmentOffer(data = {}) {
        const isAutoSelection = data.autoSelectionActive;
        const isExtraBag = data.offerAdditionalBaggage;
        const rowCollectionId = data.rowCollectionId;
        const options = data.options;
        const selectedBaggage = data.selectedBaggage;
        let selectedPieces = 0;
        let selectedWeight = 0;
        let isSelected = false;
        if (selectedBaggage) {
            selectedPieces = selectedBaggage.get('piecesToShow') || selectedPieces;
            selectedWeight = selectedBaggage.get('kilos') || selectedWeight;
            isSelected = selectedPieces > 0;
        }
        const firstOption = options.find((option) => !option.get('isIncludedBaggage'));
        const idRow = firstOption.get('idRow');
        const isAutoSelectionView = isAutoSelection && idRow === 'SECOND';
        const isSelectedClass = isSelected ? IS_SELECTED_CLASS : '';

        const selectedPrice = data.selectedPrice;
        const selectedRawPrice = data.selectedRawPrice || 0;
        const selectedPrimePrice = data.selectedPrimePrice;
        const selectedRawPrimePrice = data.selectedRawPrimePrice || 0;

        const isPriceSplit = this.model.shouldSplitPrice();
        const priceApplicationLevelLabel = isPriceSplit ? this.keys.dropdownPriceFlight : '';

        const selectableSegmentTemplate = this.templates.selectableSegment;
        const $segmentOffer = this.$el.find(this.selectors.segmentOffer);
        const isDisplayTotalBaggageWeightAllowance = Odigeo.AB.isDisplayTotalBaggageWeightAllowance;


        const segmentOfferData = {
            isExtraBag,
            selectedPrice,
            selectedPrimePrice,
            selectedPieces,
            selectedWeight,
            isSelected,
            isSelectedClass,
            isAutoSelectionView,
            rowCollectionId,
            keys: this.keys,
            applicationLevel: data.applicationLevel,
            priceApplicationLevelLabel,
            isDisplayTotalBaggageWeightAllowance,
            hasIncludedBaggage: this.model.hasIncludedBaggage(),
            selectedRawPrice,
            selectedRawPrimePrice,
            primeInfo: this.getPrimeInfo() || {},
            isSimilarSelection: Boolean(data.isSimilarSelection),
        };

        $segmentOffer.html(selectableSegmentTemplate(segmentOfferData));
        this.renderExtraBag(isExtraBag, options);
    },
    renderExtraBag(isExtraBag, options) {
        if (isExtraBag) {
            const includedInfo = this.getExtraBagIncludedInfo(options);
            const includedInfoTemplate = this.templates.includedSegment;
            const $includedInfoWrapper = this.$el.find(this.selectors.segmentIncludedInfo);
            $includedInfoWrapper.html(includedInfoTemplate({
                keys: this.keys,
                ...includedInfo,
            }));
        }
    },
    getExtraBagIncludedInfo(options) {
        let kilos = 0;
        let pieces = 0;
        let isWeightBased = false;

        const includedOption = options.find((option) => option.get('isIncludedBaggage'));
        if (includedOption) {
            isWeightBased = includedOption.get('isWeightBased');
            kilos = isWeightBased ? includedOption.get('kilos') : kilos;
            pieces = includedOption.get('pieces');
        }

        return {
            isWeightBased,
            kilos,
            pieces,
        };
    },
    renderSegmentInfo(data = {}) {
        const segmentTypeInfo = this.getSegmentTypeInfo();
        const airportInfo = this.getAirportInfo(data);
        const templateData = {
            ...airportInfo,
            segmentTypeIcon: segmentTypeInfo.iconClass,
            carrierCode: data.carrierCode,
            commercialBrandCode: data.commercialBrandCode,
            offerAdditionalBaggage: data.offerAdditionalBaggage,
            shouldDisplayGenericLogo: data.shouldDisplayGenericLogo,
            keys: {
                needMoreSpace: this.keys.needMoreSpace,
                segmentType: segmentTypeInfo.segmentType,
            },
        };

        this.$el.find(this.selectors.segmentInfo).html(this.templates.airports(templateData));
    },
    getAirportInfo(data) {
        return {
            departureCity: data.departure.cityName,
            arrivalCity: data.arrival.cityName,
        };
    },
    getSegmentTypeInfo() {
        let segmentTypeInfo = {};

        if (this.model.isOneWay()) {
            segmentTypeInfo = this.getOneWaySegmentInfo();
        } else if (this.model.isRoundTrip()) {
            segmentTypeInfo = this.getRoundTripSegmentInfo();
        } else if (this.model.isMultiTrip()) {
            segmentTypeInfo = this.getMultiTripSegmentInfo();
        }

        return segmentTypeInfo;
    },
    getOneWaySegmentInfo() {
        return {
            iconClass: ICON_CLASS.DEPARTURE,
            segmentType: this.keys.flightTypeOutbound,
        };
    },
    getRoundTripSegmentInfo() {
        const segment = this.model.get('segment');
        return this.model.hasApplicationLevelItinerary()
            ? {
                iconClass: ICON_CLASS.ROUNDTRIP,
                segmentType: this.keys.flightTypeRoundtrip,
            }
            : {
                iconClass: ICON_CLASS.DEPARTURE,
                segmentType: segment === 0 ? this.keys.flightTypeOutbound : this.keys.flightTypeInbound,
            };
    },
    getMultiTripSegmentInfo() {
        const segment = this.model.get('segment');
        return this.model.hasApplicationLevelItinerary()
            ? this.getRoundTripSegmentInfo()
            : {
                iconClass: ICON_CLASS.DEPARTURE,
                segmentType: this.keys[`flightTypeMultitrip${segment}`],
            };
    },
}))));
